import { ClaimLanguage } from '@shared/types/api/user';
export const CLAIM_LANGUAGE_FLAG_IMAGES = {
    [ClaimLanguage.French]: require('@declaration/assets/images/language/flag_fr.png'),
    [ClaimLanguage.English]: require('@declaration/assets/images/language/flag_en.png'),
    [ClaimLanguage.Italiano]: require('@declaration/assets/images/language/flag_it.png'),
};
